export default __webpack_public_path__ + "static/media/course6.71d46459.png";